import $ from 'jquery';
import {isMobile, isMaxHeight} from '../utilities';


class StripOffset {
  constructor(element){
    this.$el = $(element);
    this.addPadding();
    $(window).on('resize', this.addPadding.bind(this));
  }

  checkBoxHeight(){
    let $box = this.$el.find('.info');
    let $boxContainer = this.$el.find('.strip-content');
    let boxHeight = $box.innerHeight() + parseInt($box.css('top'));
    let boxContainerHeight = $boxContainer.innerHeight();
    let containerPadding = parseInt(this.$el.css('padding-top'));
    let offsetHeight = boxHeight - boxContainerHeight + containerPadding;

    return offsetHeight;
  }

  addPadding(){
    if(!isMobile() && !isMaxHeight()){
      this.$el.css({'padding-bottom' : this.checkBoxHeight()});
    } else if(isMobile()){
      this.$el.css({'padding-bottom' : parseInt(this.$el.css('padding-top'))});
    }
  }

}

$('.offset-text-and-image.strip-component').each((index, element)=>{
  if(!$(element).parent().hasClass('slide')){
    //make sure that this is a non-carousel strip offset
    new StripOffset(element);
  }
});
